import React, {Suspense} from 'react'
import PropTypes from 'prop-types'
import {Flex, Spinner} from '@chakra-ui/react'

const Loading = ({children}) => (
  <Suspense
    fallback={
      <Flex justify="center" align="center">
        <Spinner />
      </Flex>
    }
  >
    {children}
  </Suspense>
)

Loading.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Loading
